"use client";

import { ProductGroupLevel } from "@/types/product-group";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import ProductsFilterByProductGroupAccordion from "./products-filter-by-product-group";
import ProductsViewSettings from "./products-view-settings";
import { OpenFilterCarouselContext } from "@/context/product-params-context";
import { useCookies } from "react-cookie";
import Box from "@mui/material/Box";
import LayoutSearchFilter from "@/components/layout/layout-search-filter";
import { useAppSelector } from "@/redux/hooks";
import { RootState } from "@/redux/store";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useProductsFilters } from "@/hooks/useProductsFilters";
import { useSearchParams } from "next/navigation";

export default function ProductFilters() {
    const theme = useTheme();
    const searchParams = useSearchParams();

    const productsParams = useAppSelector((state: RootState) => state.products);
    const { updateFilters } = useProductsFilters();

    const [localSearch, setLocalSearch] = useState(productsParams.SearchText || "");
    const [cookie, setCookie] = useCookies(["OpenFilterCarousel"]);
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const getOpenAccordionFromUrl = () => {
        if (searchParams.get("Company")) return "brands";
        if (searchParams.get("Car")) return "cars";
        if (searchParams.get("Section")) return "parts";

        return "";
    };


    const searchParamsKey = searchParams.toString();

    const [openFilterCarousel, setOpenFilterCarouselRaw] = useState<string>(() => {
        const urlAccordion = getOpenAccordionFromUrl();

        return urlAccordion || cookie.OpenFilterCarousel || (isDesktop ? "cars" : "");
    });

    useEffect(() => {
        setLocalSearch(productsParams.SearchText ?? "");
    }, [productsParams.SearchText]);

    const isHydrated = useRef(false);


    useEffect(() => {
        const urlAccordion = getOpenAccordionFromUrl();

        if (!urlAccordion) return;

        setOpenFilterCarouselRaw(urlAccordion);
        setCookie("OpenFilterCarousel", urlAccordion, { path: "/" });
    }, [searchParamsKey]);

    useEffect(() => {
        if (productsParams && Object.keys(productsParams).length > 0) {
            isHydrated.current = true;
        }
    }, [productsParams]);

    useEffect(() => {
        if (!isHydrated.current) return;

        if ((productsParams.SearchText ?? "") === localSearch) return;

        const t = setTimeout(() => {
            updateFilters({SearchText: localSearch});
        }, 400);

        return () => clearTimeout(t);
    }, [localSearch, productsParams.SearchText, updateFilters]);

    const setOpenFilterCarousel = (value: string) => {
        setOpenFilterCarouselRaw((prev) => {
            const nextValue = prev === value ? "" : value;

            setCookie("OpenFilterCarousel", nextValue, { path: "/" });

            return nextValue;
        });
    };

    return (
        <OpenFilterCarouselContext.Provider
            value={{ openFilterCarousel, setOpenFilterCarousel }}
        >
            <Box id="products-search" pl={{ md: 3, xs: 0 }} pr={{ md: 3, xs: 0 }}>
                <LayoutSearchFilter
                    productsPage
                    searchText={localSearch}
                    setSearchText={(text) => setLocalSearch(text)}
                />
            </Box>

            <ProductsViewSettings />

            <Box sx={{ mt: 1 }}>
                <ProductsFilterByProductGroupAccordion
                    type={ProductGroupLevel.Car}
                    title="خودرو‌ها"
                    name="cars"
                />
            </Box>

            <Box>
                <ProductsFilterByProductGroupAccordion
                    type={ProductGroupLevel.Company}
                    title="برند‌ها"
                    name="brands"
                />
            </Box>

            <Box>
                <ProductsFilterByProductGroupAccordion
                    type={ProductGroupLevel.Section}
                    title="بخش ها"
                    name="parts"
                />
            </Box>

        </OpenFilterCarouselContext.Provider>
    );
}
